import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_apparel: FaireCategoryEntity = {
  token: "cat_apparel",
  type: "category",
  name: "Apparel",
  level: 1,
  href: "/category/apparel",
  childCategoryTokens: [
    "cat_apparel-all",
    "cat_apparel-new-products",
    "cat_apparel-new-brands",
    "cat_apparel-bestsellers",
    "cat_apparel-preorder",
    "cat_apparel-women",
    "cat_apparel-men",
    "cat_apparel-kids",
    "cat_apparel-baby",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
